const AmityCourseHeader = [
    { id: 1, label: "Does the university offer PhD programmes?", var: "coursefee" },
    { id: 2, label: "Does the university offer MPhil programmes?", var: "hostelfee" },
];

export default AmityCourseHeader;
